import {CloseButton, ProgressBar} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import {formatFileSize} from '../../helpers/formatFileSize'

interface UploadFileProps {
  file: File
  removeFile: () => void
  isUploading: boolean
  uploadProgress: number
}

function UploadFile({file, removeFile, isUploading, uploadProgress}: UploadFileProps) {
  return (
    <section
      className="pt-10 px-8 border-dashed rounded border-success position-relative"
      style={{borderWidth: '1px'}}
    >
      <CloseButton
        className="position-absolute"
        style={{top: '10px', right: '10px'}}
        onClick={removeFile}
      />
      <div className="d-flex pb-8">
        <div className="px-4 py-5 rounded-3 bg-white border shadow-sm">
          <img src={toAbsoluteUrl('/media/svg/brand-logos/xlsx.svg')} style={{width: '30px'}} />
        </div>
        <div className="ps-6 py-3">
          <div className="fw-medium fs-5 text-gray-800">{file.name}</div>
          <div className="text-gray-600 ">{formatFileSize(file.size)}</div>
        </div>
      </div>
      {isUploading && (
        <div className="d-flex border-top border-gray-300 mb-10 pt-7 align-items-center justify-content-between">
          <div style={{width: '90%'}}>
            <ProgressBar
              striped
              now={uploadProgress}
              min={0}
              max={100}
              variant="success"
              className="bg-gray-300"
            />
          </div>
          <div className="h-100 pb-1 text-gray-600">{uploadProgress}%</div>
        </div>
      )}
    </section>
  )
}

export default UploadFile
